<template>
  <div class='container'>
    <section class='header about'>
      <h5>ABOUT</h5>
      <h2>Let me introduce myself.</h2>
    </section>

    <div class='about-desc'>
      <v-img class='my-5' src='@/assets/about.jpeg'></v-img>
      <p class='text-center welcome'>
        Hello! I am Dom and welcome to my simple web portfolio! Thank you for taking the time to visit.
        I have been programming for many years now, from college doing simple statistics and visualizations in Python, to developing enterprise cloud software in WorkForce Software platform, to developing web apps primarily using latest web technologies. Here are some of the technologies I have used.
      </p>
    </div>

    <div class="skills center">
      <img class="skills__img" width="46" height="46" alt="Go" src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/go/go-original-wordmark.svg"/>
      <img class="skills__img" width="46" height="46" alt="Angular" src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/angular/angular-original.svg"/>
      <img class="skills__img" width="46" height="46" alt="Vue" src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/vuejs/vuejs-original.svg"/>
      <img class="skills__img" width="46" height="46" alt="React" src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg"/>
      <img class="skills__img" width="46" height="46" alt="Node.js" src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nodejs/nodejs-original-wordmark.svg"/>
      <img class="skills__img" width="46" height="46" alt="Express" src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/express/express-original-wordmark.svg"/>
      <img class="skills__img" width="46" height="46" alt="TypeScript" src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/typescript/typescript-original.svg"/>
      <img class="skills__img" width="46" height="46" alt="JavaScript" src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/javascript/javascript-original.svg"/>
      <img class="skills__img" width="46" height="46" alt="HTML" src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/html5/html5-original.svg"/>
      <img class="skills__img" width="46" height="46" alt="CSS" src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/css3/css3-original.svg"/>
      <img class="skills__img" width="46" height="46" alt="MongoDB" src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/mongodb/mongodb-original-wordmark.svg"/>
      <img class="skills__img" width="46" height="46" alt="MySQL" src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/mysql/mysql-original-wordmark.svg"/>
      <img class="skills__img" width="46" height="46" alt="Git" src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/git/git-original.svg"/>
      <img class="skills__img" width="46" height="46" alt="AWS" src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/amazonwebservices/amazonwebservices-original-wordmark.svg"/>
      <img class="skills__img" width="46" height="46" alt="Firebase" src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/firebase/firebase-plain-wordmark.svg"/>
      <img class="skills__img" width="46" height="46" alt="Linux" src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/linux/linux-original.svg"/>
      <img class="skills__img" width="46" height="46" alt="Rancher" src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/rancher/rancher-original-wordmark.svg"/>
      <img class="skills__img" width="46" height="46" alt="Github" src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/github/github-original.svg"/>
      <img class="skills__img" width="46" height="46" alt="Gitlab" src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/gitlab/gitlab-original.svg"/>
      <img class="skills__img" width="46" height="46" alt="Docker" src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/docker/docker-original.svg"/>
      <img class="skills__img" width="46" height="46" alt="Vuetify" src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/vuetify/vuetify-original.svg"/>
      <img class="skills__img" width="46" height="46" alt="Angular Material" src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/angularmaterial/angularmaterial-original.svg"/>
      <img class="skills__img" width="46" height="46" alt="VSCode" src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/vscode/vscode-original.svg"/>
    </div>
    <!-- <div class='about-skills'>
      <v-row>
        <v-col cols=6 md=3>
          <v-card class='text-center py-2 px-1 d-flex flex-column align-center' height='100%'>
            <div>
              <v-img contain src='@/assets/techs/html.png' width='36' height='36'></v-img>
            </div>
            <v-card-title class='pa-0'>HTML</v-card-title>
          </v-card>
        </v-col>
        <v-col cols=6 md=3>
          <v-card class='text-center py-2 px-1 d-flex flex-column align-center' height='100%'>
            <div>
              <v-img contain src='@/assets/techs/css.png' width='36' height='36'></v-img>
            </div>
            <v-card-title class='pa-0'>CSS</v-card-title>
          </v-card>
        </v-col>
        <v-col cols=6 md=3>
          <v-card class='text-center py-2 px-1 d-flex flex-column align-center' height='100%'>
            <div>
              <v-img contain src='@/assets/techs/js.png' width='36' height='36'></v-img>
            </div>
            <v-card-title class='pa-0'>JavaScript</v-card-title>
          </v-card>
        </v-col>
        <v-col cols=6 md=3>
          <v-card class='text-center py-2 px-1 d-flex flex-column align-center' height='100%'>
            <div>
              <v-img contain src='@/assets/techs/vue.png' width='36' height='36'></v-img>
            </div>
            <v-card-title class='pa-0'>Vue.js</v-card-title>
          </v-card>
        </v-col>
        <v-col cols=6 md=3>
          <v-card class='text-center py-2 px-1 d-flex flex-column align-center' height='100%'>
            <div>
              <v-img contain src='@/assets/techs/node.png' width='55' height='36'></v-img>
            </div>
            <v-card-title class='pa-0'>Node.js</v-card-title>
          </v-card>
        </v-col>
        <v-col cols=6 md=3>
          <v-card class='text-center py-2 px-1 d-flex flex-column align-center' height='100%'>
            <div>
              <v-img contain src='@/assets/techs/express.png' width='90' height='36'></v-img>
            </div>
            <v-card-title class='pa-0'>Express</v-card-title>
          </v-card>
        </v-col>
        <v-col cols=6 md=3>
          <v-card class='text-center py-2 px-1 d-flex flex-column align-center' height='100%'>
            <div>
              <v-img src='@/assets/techs/mdb.png' width='36' height='36'></v-img>
            </div>
            <v-card-title class='pa-0'>MongoDB</v-card-title>
          </v-card>
        </v-col>
        <v-col cols=6 md=3>
          <v-card class='text-center py-2 px-1 d-flex flex-column align-center' height='100%'>
            <div>
              <v-img contain src='@/assets/techs/python.jpg' width='36' height='36'></v-img>
            </div>
            <v-card-title class='pa-0'>Python</v-card-title>
          </v-card>
        </v-col>
        <v-col cols=6 md=3>
          <v-card class='text-center py-2 px-1'>
            <v-icon large >mdi-database</v-icon>
            <v-card-title class='wfs pa-0 justify-center'>SQL</v-card-title>
          </v-card>
        </v-col>
        <v-col cols=6 md=3>
          <v-card class='text-center py-2 px-1 d-flex flex-column align-center' height='100%'>
            <div>
              <v-img contain src='@/assets/techs/wfs.jpg' width='36' height='36'></v-img>
            </div>
            <v-card-title class='pa-0'>Workforce Software</v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    }
  },

}
</script>

<style scoped>
/* layout */
.container {
  padding: 90px 20px;
  color: rgb(77, 76, 76);
}

/* typography */

.about-desc {
  font-family: var(--lora);
}

.about-desc > p {
  line-height: 1.8rem;
}

.welcome {
  color: var(--paragraph);
  font-size: 1.2rem;
}

.about-skills {
  font-family: var(--acme);
  font-size: 1.2rem;
}

.v-card__title {
  font-size: 1rem;
}

/* others */

.about-desc .v-image {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin: 0 auto;
}

.bor-red {
  border-left: .2rem solid red;
}

.bor-blue {
  border-left: .2rem solid blue;
}
.bor-pink {
  border-left: .2rem solid rgb(255, 0, 200);
}
.bor-green {
  border-left: .2rem solid rgb(65, 230, 79);
}


.cv-container {
  margin-top: 4.5rem;
}

.v-btn.cv {
  color: white;
  font-family: var(--acme);
  font-size: 1rem;
  /* letter-spacing: .3rem; */

  padding: 1.5rem 2.1rem;
}

.skills {
  text-align: center;
}
.skills__img {
    margin: 8px 4px;
}

@media (min-width: 960px) {
  .v-btn.cv {
    color: white;
    font-family: var(--acme);
    font-size: 1.1rem;
    letter-spacing: .3rem;

    padding: 1.4rem 2.5rem;
  }
}

</style>